import './styles.scss';
import React from 'react';
import { ReactComponent as SearchIcon } from 'assets/icons/search-icon.svg';
import { InputProps } from '@cokitchen/cokitchen-components';

const SearchInput = (props: InputProps) => {
  const { value, placeholder, onChange } = props;

  return (
    <div className='search-input__wrapper'>
      <SearchIcon />
      <input type='text' value={value} placeholder={placeholder} onChange={onChange} />
    </div>
  );
};

export default SearchInput;
